import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { VisitorTypeModifyRequest } from "./VisitorTypeModifyRequest";

@Injectable()
export class DataService_MultiStationVisitorTypeMaintenance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	VisitorTypeTableInfoSelect() {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorTypeTableInfoSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorTypeTableSelectList() {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorTypeTableSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorTypeInUse(parms: VisitorTypeModifyRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorTypeInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorTypeInsert(parms: VisitorTypeModifyRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorTypeInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorTypeUpdate(parms: VisitorTypeModifyRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorTypeUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorTypeToggle(VisitorTypeID: number, Active: number) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorTypeToggle?VisitorTypeID=" + VisitorTypeID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorTypeDelete(VisitorTypeID: number) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorTypeDelete?VisitorTypeID=" + VisitorTypeID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
